(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["quiz.htm"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"content question\">\r\n\t<div class=\"container\">\r\n\t\t<div class=\"row\">\r\n\t\t\t<div class=\"hidden-xs col-md-12 current-question\">\r\n\t\t\t\t<span class=\"num\" data-current>";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "currentQuestion"), env.opts.autoescape);
output += "</span>/<span class=\"ntasks\">";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "nQuestionsTotal"), env.opts.autoescape);
output += "</span>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t\t<div class=\"row\">\r\n\t\t\t<div class=\"col-md-12 light-box\" data-question>\r\n\r\n\r\n\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n</div>\r\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
